module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "height": "20",
      "width": "20",
      "viewBox": "-8 0 55 35",
      "preserveAspectRatio": "xMidYMid meet"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      }
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    style: (("fill:" + (!!_vm.active ? _vm.globalColors.primary : 'white') + ";stroke:" + (_vm.globalColors.primary) + ";stroke-width: 0.5rem;")),
    attrs: {
      "transform": "translate(-1138.000000, -189.000000)",
      "fill": "#FF6600"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(1138.000000, 189.000000)"
    }
  }, [_c('path', {
    staticClass: "heart-path",
    attrs: {
      "d": "M28.279875,0 C24.955125,0 21.6425625,1.57612185 19.5,4.13086538 C17.3574375,1.57612185 14.044875,0 10.720125,0 C4.684875,0 0,4.7259067 0,10.8140154 C0,18.2962912 6.6275625,24.3966942 16.7675625,33.4452565 L19.5,36 L22.2324375,33.4452565 C32.1725625,24.1950686 39,18.0946657 39,10.8140154 C39,4.7259067 34.315125,0 28.279875,0 Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ceb94df","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg-components/heartSvg.vue
// module id = 487
// module chunks = 1 4 5 6